import { useState, useCallback, useEffect } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { getCaseId, getClientId } from "../../../../Utils/helper";

const usePhotoSearchData = (activeTab) => {
  const [tabData, setTabData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const currentCaseId = getCaseId();

  const searchData = useCallback(
    async (additionalParams = {}) => {
      if (!currentCaseId) return;

      setLoading(true);
      setError(null);

      try {
        const response = await api_without_cancellation.get(
          "/api/photo/list-page-photo-optimized/",
          {
            params: {
              // Default parameters
              page_id: activeTab === "all" ? "" : activeTab,
              case_id: currentCaseId || "",
              all_docs: activeTab === "all" ? "True" : false,
              client_id: getClientId(),
              ...additionalParams, // Spread additional parameters
            },
          }
        );

        if (response.status === 200) {
          setTabData(response.data);
        }
      } catch (err) {
        console.error("Error searching data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [activeTab, currentCaseId, getClientId]
  );

  useEffect(() => {
    searchData();
  }, [searchData]);
  // Manual search function with additional parameters
  const search = useCallback(
    (additionalParams = {}) => {
      searchData(additionalParams);
    },
    [searchData]
  );

  return {
    tabData,
    loading,
    error,
    refetch: search,
  };
};

export default usePhotoSearchData;
